<template>
  <div class="bg-gray">
    <navigation-bar :mode="'Admin'"></navigation-bar>
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 style="float:left;">Create Coupon</h1>
                  </div>
                </div>
                <!-- Content -->
                <div class="row">
                  <div class="col-sm-3">
                    <input class="form-control" v-model="store.state.name" placeholder="Coupon Name">
                    <button style="margin-top:20px" @click="create" class="btn btn-primary btn-blue">Create Coupon</button>
                  </div>
                </div>
              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar.vue'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AdminCouponsStore from './AdminCreateCouponStore'
import AdminPermissionsUtils from './AdminPermissionsUtils'

export default {
  name: 'AdminCreateCoupon',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: AdminCouponsStore,
      adminUtils: AdminPermissionsUtils
    }
  },
  mounted () {
    this.adminUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;

    },(err) => {
      this.$toasted.show(err, { type: 'error', duration: 2500 })
    })
  },
  methods: {
    create: function() {
      this.store.createCoupon(data => {
        this.$toasted.show('Coupon Created', { type: 'success', duration: 2500 })
      },err => {
        this.$toasted.show(err, { type: 'error', duration: 2500 })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminCreateCoupon.vue